import { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  InputBase,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseConsulators } from "./UseConsulators";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

export default function Consulators(props) {
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    GetOperators,
    GetConsultants,
    deleteConsultant,
    AddConsultant,
    UpdateConsultant,
  } = UseConsulators();
  const [consultantRes, setConsultantRes] = useState();
  const [operatorsRes, setOperatorsRes] = useState();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({ userID: undefined });

  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetConsultants(
      myPc,
      search,
      (consultant) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(consultant.pageCondition.totalPage);
          return;
        }
        setConsultantRes(consultant);
      },
      true
    );
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    setProgress(true);
    GetOperators((operators) => {
      setOperatorsRes(operators);
      return setOpen(true);
    });
  };

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowNO",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "userID",
      width: 70,
      align: "center",
      headerName: "شناسه کاربر",
      headerAlign: "center",
      hide: true,
    },

    {
      field: "firstName",
      headerName: "نام",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.lastName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "شماره موبایل",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "gender",
      headerName: "جنسیت",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.gender ? "آقا" : "خانم"}
          </Typography>
        );
      },
    },
    {
      field: "تعلیق",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "تعلیق",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.suspend ? (
              <Tooltip title="عملیات تعلیق">
                <IconButton
                  onClick={() =>
                    setCheckState({
                      show: true,
                      suspend: false,
                      id: cellValues.row.id,
                      name:
                        "عدم تعلیق کاربر " +
                        cellValues.row.firstName +
                        " " +
                        cellValues.row.lastName,
                    })
                  }
                >
                  <LockIcon color="secondary" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="عملیات تعلیق">
                <IconButton
                  onClick={() =>
                    setCheckState({
                      show: true,
                      suspend: true,
                      id: cellValues.row.id,
                      name:
                        " تعلیق کاربر " +
                        cellValues.row.firstName +
                        " " +
                        cellValues.row.lastName,
                    })
                  }
                >
                  <LockOpenIcon color="secondary" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 80,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Delete">
            <IconButton
              sx={{ ml: 1 }}
              onClick={() => {
                setDeleteState({
                  show: true,
                  name:
                    cellValues.row.firstName + " " + cellValues.row.lastName,
                  id: cellValues.row.id,
                });
              }}
            >
              <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 210,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/consulators" }],
      }}
    >
      <Dialog
        open={open}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiPaper-root ": {
            height: "30",
          },
        }}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography color="error" variant="subtitle2" sx={{ mb: 2 }}>
            کاربر مورد نظر خود را انتخاب کنید
          </Typography>
          {operatorsRes && (
            <Autocomplete
              size="small"
              value={state.userID ? state.userID : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({ ...state, userID: newValue });
                } else {
                  setState({ ...state, userID: undefined });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return operatorsRes?.find((m) => m.userID == option).operator;
                }
                return "";
              }}
              fullWidth
              options={operatorsRes.map((m) => m.userID)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="کاربر"
                />
              )}
            />
          )}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, m: 2 }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                setProgress(true);
                AddConsultant(state, () => {
                  GetConsultants(
                    myPc,
                    search,
                    (consultant) => {
                      setConsultantRes(consultant);
                    },
                    false
                  );
                  setState({ userID: undefined });
                  setOpen(false);
                });
              }}
            >
              افزودن
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => {
                setState({ userID: undefined });
                setOpen(false);
              }}
            >
              انصراف
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      {consultantRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={consultantRes.pageCondition.pageCount}
          rows={consultantRes.items}
          paginationMode="server"
          page={consultantRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={consultantRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              newFunc: newFunc,
              rowCount: consultantRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"مشاور"}
        callback={() => {
          setProgress(true);
          deleteConsultant(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let state = {
            id: checkState.id,
            suspend: checkState.suspend,
          };
          setProgress(true);
          UpdateConsultant(state, () => {
            setProgress(false);
            GetConsultants(
              myPc,
              search,
              (consultant) => {
                setConsultantRes(consultant);
              },
              false
            );
          });
        }}
      />
    </Detail>
  );
}
